module.exports = __webpack_public_path__ + "img/bg-login.4d4700d6.png";